import { useMemo } from 'react';
import type { PopoverProps } from '@mui/material';
import { Typography } from '@mui/material';

import type { WalletInfo } from 'src/types/wallet';

import { BodyContainer, BodyItemContainer, Container, IconContainer, StyledPopover, TopContainer, TopLeftContainer, WrapperContainer } from './styled';
import IconButton from '../IconButton';
import WalletItem from '../WalletItem';

import { ReactComponent as Close32Icon } from 'src/assets/svg/Close32.svg';

type ConnectWalletPopoverProps = Omit<PopoverProps, 'children'> & {
  walletList: WalletInfo[];
  handleAccount: (wallet: WalletInfo) => void;
};

export default function ConnectWalletPopover({ walletList, handleAccount, onClose, ...remainder }: ConnectWalletPopoverProps) {
  const installedExtensions = useMemo(() => walletList.filter((item) => item.isInstalled), [walletList]);

  const uninstalledExtensions = useMemo(() => walletList.filter((item) => !item.isInstalled), [walletList]);
  return (
    <WrapperContainer data-is-open={remainder.open}>
      <StyledPopover onClose={onClose} {...remainder}>
        <Container>
          <TopContainer>
            <TopLeftContainer>
              <Typography variant="h2">Connect Wallet</Typography>
            </TopLeftContainer>
            <IconButton
              onClick={() => {
                onClose?.({}, 'backdropClick');
              }}
            >
              <IconContainer>
                <Close32Icon />
              </IconContainer>
            </IconButton>
          </TopContainer>
          <BodyContainer>
            {installedExtensions.length > 0 && (
              <BodyItemContainer>
                {installedExtensions.map((item) => (
                  <WalletItem key={item.name} walletInfo={item} onClick={handleAccount} />
                ))}
              </BodyItemContainer>
            )}

            {uninstalledExtensions.length > 0 && (
              <BodyItemContainer>
                <Typography variant="h4">Uninstalled Wallets</Typography>

                {uninstalledExtensions.map((item) => (
                  <WalletItem key={item.name} walletInfo={item} onClick={handleAccount} />
                ))}
              </BodyItemContainer>
            )}
          </BodyContainer>
        </Container>
      </StyledPopover>
    </WrapperContainer>
  );
}
